import { Box, Button, Divider, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useEffect, useState } from "react";
import { useAuth } from "../../providers/AuthProvider";
import { useNavigate, useParams } from "react-router-dom";
import { NotificationService } from "../../api/notification.service";
import { useAlert } from "../../hooks/useAlert";
import { useTranslation } from "react-i18next";

const NotificationEdit = () => {
  const { t } = useTranslation();
  const { userInfo } = useAuth();
  const navigate = useNavigate();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const { id } = useParams();
  const showAlert = useAlert();
  const [notification, setNotification] = useState();

  const handleFormSubmit = (values) => {
    console.log("values:", values);
    updateNotification(values);
  };

  // update
  const updateNotification = async (data) => {
    try {
      await NotificationService.update(id, data, userInfo.jwt);
      showAlert(t("Edit Notification successfully"), "success");
      navigate("/notifications");
    } catch (error) {
      showAlert(t("Edit Notification error"), "error");
      console.log("Error edit", error);
    }
  };

  useEffect(() => {
    //get data Id
    const fetchNotificationById = async (id) => {
      const data = await NotificationService.getById(id);
      setNotification(data);
    };

    fetchNotificationById(id);
  }, [id]);

  if (!notification) return;

  return (
    <Box m="20px">
      <Header title={t("EDIT NOTIFICATION")} subtitle={t("Edit Notification")} />

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={{
          id: notification.id,
          title: notification.title,
          details: notification.details,
        }}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              mt="40px"
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              <TextField
                fullWidth
                disabled
                InputLabelProps={{
                  shrink: true,
                }}
                variant="filled"
                type="text"
                label="Id"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.id}
                // value={notification.id}
                // defaultValue={notification.id}
                name="id"
                error={!!touched.id && !!errors.id}
                helperText={touched.id && errors.id}
                sx={{ gridColumn: "span 2" }}
              />
              <Divider sx={{ gridColumn: "span 4" }}></Divider>
              <TextField
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                variant="filled"
                color="secondary"
                type="text"
                label={t("Title")}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.title}
                // value={notification.title}
                // defaultValue={notification.title}
                name="title"
                error={!!touched.title && !!errors.title}
                helperText={touched.title && errors.title}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                variant="filled"
                color="secondary"
                type="text"
                label={t("Details")}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.details}
                name="details"
                error={!!touched.details && !!errors.details}
                helperText={touched.details && errors.details}
                sx={{ gridColumn: "span 4" }}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px" gap={2}>
              <Button
                color="secondary"
                variant="outlined"
                onClick={() => navigate(-1)}
              >
                {t("Go Back")}
              </Button>
              <Button type="submit" color="secondary" variant="contained">
                {t("Save")}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  title: yup.string().required("required"),
  details: yup.string().required("required"),
});

// const initialValues = {
//   title: "",
//   details: "",
// };

export default NotificationEdit;
